import React from "react"
import CurrencyInput from "react-currency-input-field"
import classNames from "classnames"
import {EditMode} from "./utils"

export function EditLimitSection({
	hasExistingOverride,
	editMode,
	setEditMode,
	amount,
	onAmountChange,
	endDate,
	onEndDateChange,
	todayDate,
}: {
	hasExistingOverride: boolean
	editMode: EditMode
	setEditMode: (mode: EditMode) => void
	amount: string
	onAmountChange: (value: string | undefined) => void
	endDate: string
	onEndDateChange: (value: string) => void
	todayDate: string
}) {
	return (
		<div
			className={classNames(
				"limit-override-mode-selector",
				hasExistingOverride && "limit-override-mode-selector--border",
				hasExistingOverride && editMode === EditMode.Edit && "limit-override-mode-selector--selected"
			)}
			onClick={hasExistingOverride ? () => setEditMode(EditMode.Edit) : undefined}
		>
			{hasExistingOverride && (
				<span className="limit-override-radio">
					<input
						type="radio"
						name="editMode"
						value={EditMode.Edit}
						checked={editMode === EditMode.Edit}
						onChange={() => setEditMode(EditMode.Edit)}
					/>
					<span className="limit-override-radio-label">Edit Limit</span>
				</span>
			)}

			{(!hasExistingOverride || editMode === EditMode.Edit) && (
				<div className="limit-override-form-row">
					<div className="field">
						<label className="label">Amount</label>
						<div className="control">
							<div className="input-with-prefix">
								<span className="input-prefix">$</span>
								<CurrencyInput
									className="input"
									value={amount}
									onValueChange={onAmountChange}
									placeholder="0.00"
									decimalsLimit={2}
									groupSeparator=","
									decimalSeparator="."
									allowNegativeValue={false}
								/>
							</div>
						</div>
					</div>

					<div className="field">
						<label className="label">
							End Date <span className="label-optional">(optional)</span>
						</label>
						<div className="control">
							<input
								className="input"
								type="date"
								value={endDate}
								min={todayDate}
								onChange={(e) => onEndDateChange(e.target.value)}
							/>
						</div>
					</div>
				</div>
			)}
		</div>
	)
}
